import { v4 as uuidv4 } from "uuid";
// import authService from "../../services/authService.js";

import apiSoapDB from "../../api/soapdb";
import { parseDateOrToday } from "../../helpers";
import {
  parseAccountSummaryData,
  matchAccountsWithSummaries,
  parseBankDetailData,
  extractTransactionSpecificDetails,
  matchLedgerWithWorksheetDetail,
  parsePaymentData,
} from "../../cashhelpers";

export default {
  namespaced: true,

  state: {
    cashAccountGroups: [
      //(TOP LEVEL) ENTITY TYPE [DCP,GCS] -> ENTITY DETAILS -> ACCOUNT ARRAY
    ],
    // payments: [],
    ledgerDate: new Date(),
    // paymentDates: {
    //   start: new Date().setDate(new Date().getDate() - 7),
    //   end: new Date(),
    // },
  },

  getters: {
    cashAccountGroupByGUID: (state) => (guid) => {
      for (let i = 0; i < state.cashAccountGroups.length; i++) {
        if (state.cashAccountGroups[i]["generatedGUID"] == guid) {
          return state.cashAccountGroups[i];
        }
      }
      return [];
    },
    accountsForCashAccountGroups: (state, getters) => (guid) => {
      let tmp = getters.cashAccountGroupByGUID(guid);
      if (tmp && tmp.accounts) {
        return tmp.accounts;
      }

      return [];
    },
    cashAccountGroups(state) {
      return state.cashAccountGroups;
    },
    ledgerDate(state) {
      //DETAIL: MAKE SURE WE HAVE A 'ledgerDate'
      //NOTE: REALLY SHOULDN'T BE SETTING VALUES HERE, BUT WHATEVS
      if (!state.ledgerDate || isNaN(Date.parse(state.ledgerDate))) {
        let curDate = new Date();
        state.ledgerDate = `${curDate.getMonth() +
          1}/${curDate.getDate()}/${curDate.getFullYear()}`;
      }

      return state.ledgerDate;
    },
    paymentDates(state) {
      return state.paymentDates;
    },
  },

  mutations: {
    // SET_PAYMENT_DATES(state, { startDate, endDate }) {
    //   state.paymentDates.start = parseDateOrToday(startDate);
    //   state.paymentDates.end = parseDateOrToday(endDate);
    //   console.log("NEW DATES", state.paymentDates);
    // },
    SET_LEDGER_DATE_FROM_DATE(state, datValue) {
      let curDate = parseDateOrToday(datValue);
      state.ledgerDate = `${curDate.getMonth() + 1}/${curDate.getDate()}/${curDate.getFullYear()}`;
      console.log("JUST SET LEDGER DATE: " + state.ledgerDate);
    },
    replaceCashAccountGroupBasedOnGUID(state, updatedGroup) {
      //DETAIL: MUST USE .splice() HERE TO RETAIN REACTIVITY
      let i = 0;
      for (i = 0; i < state.cashAccountGroups.length; i++) {
        // DETAIL: ASSUMES THE PASSED GROUP WILL HAVE A 'generatedGUID'
        if (state.cashAccountGroups[i]["generatedGUID"] == updatedGroup.generatedGUID) {
          //NOT GOING TO USE A 'found' MARKER . . . JUST GONNA REPLACE IT INLINE
          state.cashAccountGroups.splice(i, 1, updatedGroup);
          break;
        }
      }
    },
  },

  actions: {
    async acquireAccountGroups({ dispatch, state, commit }) {
      return new Promise((resolve, reject) => {
        state.cashAccountGroups = [];

        //UPDATE ACCOUNTGROUPS/GROUPS

        Promise.all([
          dispatch("getAccountGroupsForKey", {
            searchKey: "DCP_ACCT_GROUPS_NAME",
            groupTag: "DCP",
          }),
          dispatch("getAccountGroupsForKey", {
            searchKey: "GCS_SETTINGS ",
            groupTag: "GCS",
          }),
          dispatch("getAccountGroupsForKey", {
            searchKey: "DCP_ACCT_GROUPS_MMF.",
            groupTag: "MMF",
          }),
        ])
          .then(([dcp, gcs, mmf]) => {
            //TODO:  MAKE SURE WE 'MARRY' dcp AND mmf WHEN RETRIEVING VALUES FOR DISPLAY
            state.cashAccountGroups = [...dcp, ...gcs, ...mmf]; //MERGING THE ARRAYS INTO ONE
            // console.log("ACCOUNT GROUPS:", state.cashAccountGroups);
            //HAD FAKE DISPATCH CODE HERE
            resolve(true);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });

        //FILL ACCOUNTS
        //UPDATE ACCOUNTSUMMARIES ON AN AS-NEEDED BASIS
      });
    },

    getAccountGroupsForKey(context, { searchKey, groupTag }) {
      const dbService = context.rootGetters["localdb/dbService"];

      //MAKE SURE WE HAVE LOCAL DB SERVICE?
      if (!dbService) {
        return false;
      }

      let accountGroupsArray = [];

      try {
        let stmtResp = dbService.prepareStatementQuery(
          `SELECT * from TClient_Defaults where name like '${searchKey}%'`
        );

        while (stmtResp.step()) {
          //BUILDING ACCOUNT GROUPS & PARSING ACCOUNT IDs DEPENDING ON GROUP TYPE (NO IDEA WHY THERE'S A DIFFERENCE)
          let tmpObject = stmtResp.getAsObject();

          switch (groupTag) {
            //NOTE: COULD PROBABLY REFACTOR THIS BUT GCS THROWS A WRENCH WITH ITS 'defaultValue'
            case "DCP":
              tmpObject["accountIdArray"] = tmpObject["defaultValue"]
                ? tmpObject["defaultValue"].split(":")
                : [];

              tmpObject["displayGroup"] = tmpObject.name
                .split(" ")
                .slice(1)
                .join(" ");

              break;
            case "MMF":
              tmpObject["accountIdArray"] = tmpObject["defaultValue"]
                ? tmpObject["defaultValue"].split(",")
                : [];

              tmpObject["displayGroup"] = tmpObject.name
                .split(".")
                .slice(1)
                .join(" ");

              break;
            case "GCS":
              let tmpIdArray = tmpObject["defaultValue"]
                ? tmpObject["defaultValue"].split("|").splice(21)
                : [];

              let breakIdx = tmpIdArray.indexOf("N") || ray.indexOf("Y");
              tmpObject["accountIdArray"] = breakIdx ? tmpIdArray.splice(0, breakIdx) : tmpIdArray;

              tmpObject["displayGroup"] = tmpObject.name
                .split(" ")
                .slice(1)
                .join(" ");

              break;
            default:
              break;
          }

          tmpObject["displayGroup"] = tmpObject["displayGroup"] ?? "Undefined Display Group"; //JUST A MEASURE TO MAKE SURE WE HAVE SOMETHING
          tmpObject["generatedGUID"] = uuidv4();
          tmpObject["groupTag"] = groupTag ?? "Undefined Group";
          accountGroupsArray.push(tmpObject);
        }
      } catch (error) {
        console.log("getAccountGroupsForKey (FAILED):");
        console.log(error);
      } finally {
        return accountGroupsArray;
      }
    },

    async updateAccountsForAccountGroup({ state, dispatch, rootGetters }, { groupGUID }) {
      //NOTE: IF WE COULD DEPEND ON A GIVEN ENTITY FROM A LOCATION, WE COULD SIMPLY PASS THE ENTIRE ENTITY AND UPDATE ITS 'ACCOUNTS' . . . UNFORTUNATELY THAT ISNT THE GREATEST APPROACH FOR THIS
      //NOTE: INSTEAD WE NEED TO ACCESS BOTH GROUPS OF ENTITIES IN 'state' AND FIND ONE THAT MATCHES THE UUID
      //TODO: ACQUIRE LOCAL ACCOUNT INFORMATION BASED ON PARSED ACCOUNT IDS THEN OVERLAY EACH WITH THE RETURNED DATA
      //TODO: THOUGHT ABOUT ACQUIRING THEM IN REVERSE (SOAP FIRST THEN LOCAL ACCOUNTS) BUT THERE MIGHT BE THAT ONE EDGE CASE WHERE WE HAVE A LOCAL ACCOUNT BUT NO SOAP/REMOTE DATA AND WE STILL NEED TO SHOW THE LOCAL "EMPTINESS"
      const dbService = rootGetters["localdb/dbService"];
      let acctGroup = null;
      let acctGroupPosition = 0;
      return new Promise((resolve, reject) => {
        // DETAIL: FIND ACCT GROUP BASED ON PASSED GUID

        //NOTE: MIGHT SHOULD splice() THE ENTITY FROM THE ARRAY, THEN push() IT BACK ON TO MAINTAIN REACTIVITY FOR THE ARRAY
        for (
          acctGroupPosition = 0;
          acctGroupPosition < state.cashAccountGroups.length;
          acctGroupPosition++
        ) {
          if (state.cashAccountGroups[acctGroupPosition]["generatedGUID"] == groupGUID) {
            // console.log(`acctGroupPosition: ${acctGroupPosition}`);
            acctGroup = state.cashAccountGroups[acctGroupPosition];
            break;
          }
        }

        //DETAIL:  GUARD CLAUSE TO STOP PROCESSING IF FAILS
        if (!acctGroup) {
          reject("Could not find account group!");
          return false;
        }

        if (!acctGroup.generatedGUID) {
          reject("No entity with that GUID!");
          return false;
        }

        // console.log("DASH_GET_CASH: " + acctGroup.generatedGUID);
        //TODO: GET LOCAL ACCOUNTS BASED ON ARRAY FIRST (SQL QUERY)
        let accountArray = [];
        try {
          let acctQuery = `SELECT TA.*,
          (select service from TAccount_Services where accountID = TA.rid and service = 'CASH_BALANCES_REPORTED' limit 1) IS NOT NULL as balanceIsSetAutomatically,
          (select service from TAccount_Services where accountID = TA.rid and service = 'CASH_BALANCES_SET' limit 1) IS NOT NULL as balanceIsSetManually,
          (select service from TAccount_Services where accountID = TA.rid and service in ('CASH_RECONCILIATION','CASH_RECON_BALANCE','CASH_RECON_ITEMS') limit 1) IS NOT NULL as isReconciledByTreasury
          from TAccounts TA
          where TA.rid in (${acctGroup["accountIdArray"].join(",")})
                `;

          // console.log("ACCOUNT QUERY: ", acctQuery);
          //DETAIL: ACQUIRE THE ACCOUNTS FOR THE ACCOUNT GROUP HERE (BASED ON 'accountIdArray') FROM LOCAL DATABASE (WHICH WAS INTIALLY POPULATED AT LOGIN)
          // let stmtResp = dbService.prepareStatementQuery(
          //   `SELECT TA.*, (TAS.service IS NOT NULL) as isReconciledByTreasury from TAccounts TA
          //         LEFT JOIN TAccount_Services TAS on TA.rid = TAS.accountID and TAS.service in ('CASH_RECONCILIATION','CASH_RECON_BALANCE','CASH_RECON_ITEMS')
          //         where TA.rid in (${acctGroup["accountIdArray"].join(",")})
          //         `
          // );
          let stmtResp = dbService.prepareStatementQuery(acctQuery);
          while (stmtResp.step()) {
            accountArray.push(stmtResp.getAsObject());
          }
        } catch (error) {
          console.log("updateAccountsError:", error);
        }

        //ACQUIRE SUMMARIES FOR EACH ACCOUNT (FROM SERVER)
        apiSoapDB
          .doDashboardAccountSummaryCommand(acctGroup["accountIdArray"], state.ledgerDate)
          .then((summaryResp) => {
            // console.log("SUMMARY RESP: ", summaryResp);

            if (
              summaryResp.soapResultSection &&
              summaryResp.soapResultSection.item &&
              Array.isArray(summaryResp.soapResultSection.item)
            ) {
              let summaryArray = [];
              summaryResp.soapResultSection.item.forEach((item) => {
                // console.log(item);
                //DETAIL: PARSING THE PIPE-DELINEATED DATA INTO A JSON OBJECT AND BUILDING AN ARRAY OF THE OBJECTS
                summaryArray.push(parseAccountSummaryData(item));
              });

              // console.log("TWO ARRAYS: ", accountArray, summaryArray);
              //DETAIL: MATCHING THE SUMMARY DATA WITH EACH ACCOUNT (PROBABLY A BETTER WAY OF DOING THIS, RATHER THAN "TOUCHING TWICE")
              matchAccountsWithSummaries(accountArray, summaryArray); //DETAIL: CHANGING ACCOUNT ARRAY INFORMATION HERE (JS always 'passes by ref')
              acctGroup.accounts = accountArray;
            }
            resolve(summaryResp);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            //DETAIL: ASSUMING WE MADE IT THIS FAR AND 'entity' HAS A VALUE
            state.cashAccountGroups.splice(acctGroupPosition, 1, acctGroup);
            // return; //RETURN NO MATTER WHAT BUT ONLY AFTER THE COMMAND RESOLVES
          });
      });
    },

    async getTransactionsForGroupAccount(
      { state, commit, dispatch, getters, rootGetters },
      { groupGUID, acctId }
    ) {
      return new Promise((resolve, reject) => {
        const dbService = rootGetters["localdb/dbService"];

        //MAKE SURE WE HAVE LOCAL DB SERVICE?
        if (!dbService) {
          reject("NO DB SERVICE!");
          return false;
        }

        //DETAIL: ASSUMES WE'RE REFERENCING THE ACCOUNTS FROM THE EXISTING `cashAccountGroups` OBJECT
        let acctGroup = getters["cashAccountGroupByGUID"](groupGUID);
        console.log("STEP 1 (acctGroup)", acctGroup);
        //DETAIL: NOW LET'S FIND THE EXISTING ACCOUNT
        let curAccounts = acctGroup.accounts ?? [];
        let relevantAccount = null;
        let acctPosition = 0;

        for (acctPosition = 0; acctPosition < curAccounts.length; acctPosition++) {
          if (curAccounts[acctPosition]["rid"] == acctId) {
            relevantAccount = curAccounts[acctPosition];
            break;
          }
        }

        //WARNING: EXIT IF NO ACCOUNT FOUND
        if (!relevantAccount) {
          console.log("STEP ERROR: NO RELEVANT ACCOUNT!!!");
          reject("No account found.  Can't look up transactions . . .");
          return false;
        }

        //DETAIL: PROCEED IF FOUND
        // console.log("ACCOUNT FOR TRANSACTIONS:", relevantAccount);
        console.log("STEP 2 (relevantAccount)", relevantAccount);

        let ledgerTag = `CAS${relevantAccount.acctCode}`;
        let ledgerTransactions = [];
        let bankDetails = [];
        let worksheetDetails = [];

        //DELETE EXISTING LEDGER INFO
        let deleteQuery = `delete from TCash_Ledger where tag = '${ledgerTag}'`;
        dbService.runQuery(deleteQuery);

        //DETAIL: SOAP TRANSACTION RECEIVES A LIST OF SQL LEDGER STATEMENTS
        Promise.all([
          apiSoapDB.doGetLedgerEntries(relevantAccount.rid, ledgerTag, state.ledgerDate),
          apiSoapDB.doGetBankDetails(relevantAccount.rid, state.ledgerDate),
        ])
          .then(([ledgerResp, bankDetailsResp]) => {
            console.log("STEP 2.5 (ledgerResp, bankDetailsResp)", ledgerResp, bankDetailsResp);

            //DETAIL: HANDLE LEDGER RESPONSE
            if (
              ledgerResp.soapResultSection &&
              ledgerResp.soapResultSection.item &&
              Array.isArray(ledgerResp.soapResultSection.item)
            ) {
              ledgerResp.soapResultSection.item.forEach((assumedInsertQuery) => {
                // console.log(assumedInsertQuery);
                console.log("STEP 3 (assumedInsertQuery)", assumedInsertQuery);
                dbService.runQuery(assumedInsertQuery);
              });

              let stmt = dbService.prepareStatementQuery("select * from TCash_Ledger");
              while (stmt.step()) {
                const transactionDetails = extractTransactionSpecificDetails(
                  stmt.getAsObject(),
                  "ledgerEntry"
                );
                ledgerTransactions.push(transactionDetails);
              }
              console.log("LEDGER QUERY RESULTS:", ledgerTransactions);
            }

            //DETAIL: HANDLE BANK DETAILS (ALSO MERGE DETAILS WITH PREVIOUS LEDGER INFO)
            if (
              bankDetailsResp.soapResultSection &&
              bankDetailsResp.soapResultSection.item &&
              Array.isArray(bankDetailsResp.soapResultSection.item)
            ) {
              bankDetailsResp.soapResultSection.item.forEach((detail) => {
                // console.log("DETAIL:", detail.split("\t"));
                const transactionDetails = extractTransactionSpecificDetails(
                  parseBankDetailData(detail),
                  "bankDetail"
                );
                ledgerTransactions.push(transactionDetails);
              });
            }

            console.log("LEDGER TRANSACTIONS:", ledgerTransactions);
            //DETAIL: NOW GRAB WORKSHEET DETAILS FOR TRANSACTIONS
            //NOTE: MANUALLY BUILD ARRAY OF RIDs FIRST
            let ledgerRidArray = ledgerTransactions.reduce(
              (accumulator, curTransaction) =>
                (accumulator = [...accumulator, curTransaction.rid ?? "INVALIDTRANSACTIONRID"]),
              []
            ); //DETAIL: ENDING [] IS ACTUALLY AN INITIAL VALUE

            // console.log("REDUCED LEDGER ID ARRAY:", ledgerRidArray);

            apiSoapDB
              .doGetWorksheetDetailsForMultipleTransactions(ledgerRidArray)
              .then((worksheetResp) => {
                if (
                  worksheetResp.soapResultSection &&
                  worksheetResp.soapResultSection.item &&
                  Array.isArray(worksheetResp.soapResultSection.item)
                ) {
                  // console.log("WORKSHEET DETAILS:", worksheetResp.soapResultSection.item);
                  matchLedgerWithWorksheetDetail(
                    ledgerTransactions,
                    worksheetResp.soapResultSection.item
                  );
                }
              })
              .then(() => {
                //DETAIL: SPLICE ACCOUNT BACK IN
                relevantAccount.transactions = ledgerTransactions; //WHETHER WE FIND THEM OR NOT, WE'RE GOING TO SET THE VALUE
                acctGroup.accounts.splice(acctPosition, 1, relevantAccount);
                commit("replaceCashAccountGroupBasedOnGUID", acctGroup);
                resolve(relevantAccount);
              });
          })
          .catch((err) => {
            console.log("GETTRANSACTIONSFORGROUPACCOUNT ERROR:", err);
          });
      });
    },
  },
};
